// extracted by mini-css-extract-plugin
export var contentWrapper = "SectionImageLeft-module--contentWrapper--5b349";
export var media = "SectionImageLeft-module--media--57a77";
export var wrapper = "SectionImageLeft-module--wrapper--427f0";